import { getMessages } from 'app/store/constants';

export const BOARD_BACKUPS_TEXT_LINK_BEGINNING = getMessages().getText('board_settings.backup.text-link-beginning');
export const BOARD_BACKUPS_LINK_TEXT = getMessages().getText('board_settings.backup.link-text');
export const BOARD_BACKUPS_ONEDRIVE_LINK_TEXT = getMessages().getText('board_settings.backup.one-drive.link-text');
